import store from "../store/store";

export const CFST_PENDO_DEFAULT_LABEL = "Customer Portal | Technician appointments";
export const AUTOPAY_DEENROLL_EVENT = "Customer Portal | Billing And Payment | AutoPay | De-enrollment Attempt";

// This method is used for pendo track event feature
export const pendoTrack = (name, data) => {
  const sourcewell = store.getState().ACCOUNT.isSourcewellGovernment ? "Government Sourcewell" : "";
  let trackName = name;
  if (name.includes(CFST_PENDO_DEFAULT_LABEL) && sourcewell) {
    trackName = name.replace(CFST_PENDO_DEFAULT_LABEL, `${CFST_PENDO_DEFAULT_LABEL} | ${sourcewell}`);
  }
  window.pendo?.track(trackName, data);
};

export const pendoTrackAutoPayDeenroll = ({
  contractAccountId,
  businessPartnerId,
  companyCode,
  countryCode,
  paymentMethodType,
  paymentMethodLast4,
  sessionId,
  attemptTimestamp,
}) => {
  pendoTrack(AUTOPAY_DEENROLL_EVENT, {
    contractAccountId: contractAccountId || "",
    businessPartnerId: businessPartnerId || "",
    companyCode: companyCode || "",
    countryCode: countryCode || "",
    paymentMethodType: paymentMethodType || "",
    paymentMethodLast4: paymentMethodLast4 || "",
    sessionId: sessionId || "",
    attemptTimestamp: attemptTimestamp || "",
    triggeredAt: new Date().toISOString(),
  });
};
